<template>
  <div class="login">
    <div class="login-logo">
      <a href="/">
        <img src="../assets/logo4.png"/>
      </a>
    </div>
    <div class="container">
      <div class="content-wrapper">
        <div class="content-titel"><translate>Verify the MFA device</translate></div>
        <div class="code">
          <el-input :placeholder="attrText.enterCode" v-model="securityCode" @change="onInputCode"></el-input>
          <el-button type="primary" class="submitBtn" :disabled="!isCansubmit" @click="onSubmitVerify()"><translate>Submit validation</translate></el-button>
        </div>
        <el-button type="text" @click="bindMfa = true"><translate>(MFA verify notes)</translate></el-button>
      </div>
    </div>
    <div class="copyright clearfix small">
      <div>Copyright 2013-2017 <translate>Shanghai Zhuyun Information Technology Co.,Ltd</translate></div>
      <div>Powered by
        <a href="https://cloudcare.cn/" target="_blank" class="text-primary new-block">cloudcare.cn</a>
      </div>
    </div>

    <!--弹框-->
    <el-dialog title="MFA验证须知" :visible.sync="bindMfa" class="dialog">
      <div class="dialog-content">
        <p class="text">
          <translate>1. You must install the MFA application on your smart device to continue.</translate>
        </p>
        <p class="text">
          <translate>2. Common applications that support MFA on smart devices are </translate><a style="color: #20a0ff;" href="https://promotion.aliyun.com/ntms/mobile.html" target="view_window"><translate>Identity</translate></a><translate>, Microsoft Authenticator, Google Authenticator.</translate>
        </p>
        <p class="text">
          <translate>3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.</translate>
        </p>
        <p class="text">
          <translate>4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.</translate>
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindMfa = false"><translate>Comfirm</translate></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import STORE_CONST from '../store/consts'
  export default{
    data () {
      return {
        securityCode: '',
        isCansubmit: false,
        bindMfa: false
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    methods: {
      getTranslateText () {
        return {
          'firstCode': this.$gettext('First column verification code'),
          'secondCode': this.$gettext('Second column verification code'),
          'enterCode': this.$gettext('Enter the 6-digit security code')
        }
      },
      onInputCode (val) {
        if (/^\d{6}$/.test(val)) {
          this.isCansubmit = true
        } else {
          this.isCansubmit = false
        }
      },
      onSubmitVerify () {
        this.$store.dispatch(STORE_CONST.ACCOUNT.VERIFY_MFA_CODE, {code: this.securityCode}).then(res => {
          localStorage.setItem('isAdmin', res.is_admin)
          if (res.error_message) {
            this.$notify({
              type: 'error',
              message: res.error_message,
            })
            return
          }
          if (res.is_admin) {
            this.$router.push('/dashboard')
            sessionStorage.setItem('activeIndex', '1-1')
          } else {
            this.$router.push('/operation/workgroup')
            sessionStorage.setItem('activeIndex', '1-2')
          }
        })
      }
    }
  }
</script>

<style scoped="scoped" lang='scss' rel="stylesheet/scss">
  .content-wrapper{
    .code{
      margin-top: 20px;
      padding: 0 100px;
      .submitBtn{
        width: 100%;
        margin-top: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// mfaComfirm.vue?67f08984